import { Targets } from './pages';

export default {
  key: 'targets',
  isPrivate: true,
  exact: true,
  path: '/targets',
  component: Targets,
};
